import { inject } from '@angular/core';
import {
  RouterStateSnapshot,
  ActivatedRouteSnapshot,
  ResolveFn
} from '@angular/router';
import { AppStateService } from 'shared/services/app-state/app-state.service';
import { FacilityService } from '../../services/facility/facility.service';

export const facilityResolver: ResolveFn<any> =
  (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const facilityService = inject(FacilityService);
    const appState = inject(AppStateService);

    // check cache for this facility. Couldn't get `shareReplay(1)` to work
    if (!appState.get('currentFacility')) {
      const facilityId = appState.get('currentFacilityId');
      return facilityService.getFacility(facilityId);
    }
    return undefined;
  };
